import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {ReplaySubject} from "rxjs";

export class SelectionEvent {
    public selection: any;
    public userSelection: boolean;

    constructor(selection: any, userSelection: boolean) {
        this.selection = selection;
        this.userSelection = userSelection;
    }
}

export class SelectionsEvent {
    public selections: Array<any>;
    public userSelection: boolean;

    constructor(selections: Array<any>, userSelection: boolean) {
        this.selections = selections;
        this.userSelection = userSelection;
    }
}

@Injectable()
export class FUIOptionsService {
    private _selection: any;
    public $selection: ReplaySubject<SelectionEvent>;
    public selection$: Observable<SelectionEvent>;
    private _selections: Array<any>;
    public $selections: ReplaySubject<SelectionsEvent>;
    public selections$: Observable<SelectionsEvent>;

    public $changeSelections: ReplaySubject<SelectionsEvent>;
    public changeSelections$: Observable<SelectionsEvent>;

    public valueField: string;

    constructor() {
        this.$selection = new ReplaySubject<SelectionEvent>(1);
        this.selection$ = this.$selection.asObservable();
        this.$selections = new ReplaySubject<SelectionsEvent>(1);
        this.selections$ = this.$selections.asObservable();

        this.$changeSelections = new ReplaySubject<any>(1);
        this.changeSelections$ = this.$changeSelections.asObservable();
    }

    /**
     * Return the private member selection
     * @returns {FUIOptionComponent}
     */
    get selection(): any {
        return this._selection;
    }

    /**
     * Set the active selection, if it isn't already the
     * provided selection
     * @param {FUIOptionComponent} option
     */
    set selection(selection: any) {
        this._selection = selection;
        this.$selection.next(new SelectionEvent(this._selection, false));
    }

    selectOption(option: any): void {
        this._selection = option;
        this.$selection.next(new SelectionEvent(this._selection, true));
    }

    /**
     * Return the private member selections
     * @returns {any}
     */
    get selections(): Array<any> {
        return this._selections;
    }

    /**
     * Set the active options, if it isn't already a
     * provided selection
     * @param {Array<any>} selection
     */
    set selections(selections: Array<any>) {
        this._selections = selections;
        this.$selections.next(new SelectionsEvent(this.selections, false));
        this.$changeSelections.next(new SelectionsEvent(this.selections, true));
    }

    /**
     * Toggle selections instead of replacing the full list
     * @param selection
     */
    select(selection: any): void {
        if (this._selections) {
            this._selections = this._selections.slice(0);
            const index = this._selections.findIndex((item) => item[this.valueField] === selection[this.valueField]);
            if (index > -1) {
                this._selections.splice(index, 1);
            } else {
                this._selections.push(selection);
            }
        } else {
            this._selections = new Array<any>();
            this._selections.push(selection);
        }
        this.$selections.next(new SelectionsEvent(this.selections, true));
        this.$changeSelections.next(new SelectionsEvent(this.selections, true));
    }
}
